import React from 'react';
import '../pages/home.css'
import Head from '../layout/header';
import Sec1 from '../layout/sec1';
import '../../root.css'
import Sec2 from '../layout/sec2';
import Sec3 from '../layout/sec3';
import Sec4 from '../layout/sec4';
import Preloader from '../layout/preloader';
import Footer from '../layout/footer';
import Sec5 from '../layout/sec5';
import Sec7 from '../layout/Sec7';
import Sec6 from '../layout/sec6';
const Home = () => {
    return (<>
        <Preloader />

        <div>
            <Head />
            <Sec1 />
            <Sec2 />
            <Sec3 />
            <Sec4 />
            <Sec5 />
            <Sec6 />
            <Sec7 />

            <Footer />
        </div>
    </>);
}

export default Home;